import { render, staticRenderFns } from "./FeedbacksPage.vue?vue&type=template&id=36f3f721&"
import script from "./FeedbacksPage.vue?vue&type=script&lang=js&"
export * from "./FeedbacksPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedbacksPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports